module.exports = __webpack_public_path__ + "static/img/big_btn3.1835dc06.png";